import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export const profileSettingsOptionsQueryKey = 'profile-settings-options';

export function useProfileSettingsOptions({ disabled }: { disabled?: boolean } = {}) {
    return useQuery({
        queryKey: [profileSettingsOptionsQueryKey],
        queryFn: () => sdClient.getProfileOptions({}),
        enabled: !disabled,
    });
}
